import { render, staticRenderFns } from "./brandDetection.vue?vue&type=template&id=19371329&scoped=true"
import script from "./brandDetection.vue?vue&type=script&lang=ts"
export * from "./brandDetection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19371329",
  null
  
)

export default component.exports